/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import CalendarLocale from '../calendar/et_EE';
import TimePickerLocale from '../time-picker/et_EE';

const locale = {
  lang: {
    placeholder: 'Vali kuupÃ¤ev',
    rangePlaceholder: ['Algus kuupÃ¤ev', 'LÃµpu kuupÃ¤ev'],
    ...CalendarLocale
  },
  timePickerLocale: {
    ...TimePickerLocale
  }
};

// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

export default locale;
